module.exports = __webpack_public_path__ + "static/media/arrow-right.43088faa.svg";